<template>
    <div>
        <div class="listing-header">
            <!--            <b-switch v-model="filterSelected" :value="true" v-if="selector && multiple">-->
            <!--                Mostrar marcados-->
            <!--            </b-switch>-->
            <search-input
                placeholder="Buscar por label"
                :value="labelStr"
                icon="tag"
                @input="search(searchStr, $event)"></search-input>
            <search-input
                :value="searchStr"
                @input="search($event, labelStr)"></search-input>
        </div>
        <b-table
            :data="data"
            :loading="loading"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            backend-sorting
            :default-sort-direction="defaultSortDirection"
            :default-sort="[sortField, sortDir]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" sortable>
                    {{ props.row.id }}
                </b-table-column>
                <b-table-column field="title" label="Titulo" sortable>
                    {{ props.row.title }}
                </b-table-column>
                <b-table-column field="title" label="Tipo" sortable v-if="showType">
                    <b-tag type="is-info">{{ props.row.type }}</b-tag>
                </b-table-column>
                <b-table-column field="title" label="Brightcove ID" sortable>
                    {{ props.row.bc_id }}
                </b-table-column>
                <b-table-column field="publishing_date" label="Publicado el" sortable>
                    {{ props.row.publishing_date | moment(dateFormat) }}
                </b-table-column>
                <b-table-column field="insertion_date" label="Agregado el" sortable>
                    {{ props.row.insertion_date | moment(dateFormat) }}
                </b-table-column>
                <b-table-column field="update_date" label="Actualizado el" sortable>
                    {{ props.row.update_date | moment(dateFormat) }}
                </b-table-column>
                <b-table-column label="Actions">
                    <crud-actions :id="props.row.id" resource="news" :title="props.row.title" @deleted="fetchData"
                                  v-if="!selector"/>
                    <b-button type="" pack="far" icon="check-circle" v-if="selector && !multiple"
                              @click="selectItem(props.row)"> Seleccionar </b-button>
                    <b-checkbox v-model="itemsSelected" :native-value="props.row.id" @input="cbSelected" v-if="selector && multiple" />
                </b-table-column>

            </template>
        </b-table>
    </div>
</template>

<script>
    import {Local} from '../../lib/Request';
    import SearchInput from "../fields/SearchInput";

    export default {
        name: "NewsListing",
        components: {SearchInput},
        props: {
            dataUrl: {type: String, required: true},
            value: {type: Object, require: false, default: null},
            selector: {type: Boolean, require: false, default: false},
            multiple: {type: Boolean, require: false, default: false},
            values: {
                type: Array, require: false, default: () => {
                    return []
                }
            },
            cbSelected: {
                type: Function, require: false, default: () => {
                }
            },
            showType: {Boolean, default: false},
            query: {type: Object, require: false, default: null}
        },
        data: () => {
            return {
                data: [],
                itemsSelected: [],
                total: 0,
                loading: false,
                sortField: 'insertion_date',
                sortDir: 'desc',
                defaultSortDirection: 'desc',
                page: 0,
                perPage: 10,
                dateFormat: process.env.MIX_DBT_DATE_FORMAT,
                selectedRow: null,
                searchStr: null,
                labelStr: null
            }
        },
        created() {
            if (this.selector && this.multiple) {
                this.itemsSelected = this.values
            }
            this.fetchData()
        },
        computed: {
            isSelectorMultiple() {
                return selector && multiple
            },
            searchQuery() {
                return this.searchStr !== null && this.searchStr.length >= 3 ? this.searchStr : '';
            },
            labelQuery() {
                return this.labelStr !== null && this.labelStr.length >= 3 ? this.labelStr : '';
            }
        },
        methods: {
            async fetchData() {
                try {
                    const result = await Local.get(this.dataUrl, {
                        params: {
                            'page': this.page,
                            'sortField': this.sortField,
                            'sortDir': this.sortDir,
                            'searchQuery': this.searchQuery,
                            'labelQuery': this.labelQuery,
                            ...this.query
                        }
                    });

                    this.data = result.data.data;
                    this.total = result.data.total;
                } catch (error) {
                    // todo add toast notification
                    console.error(error);
                }
            },
            onPageChange(page) {
                this.page = page;
                this.fetchData()
            },
            onSort(field, direction) {
                this.sortField = field;
                this.sortDir = direction;
                this.fetchData()
            },
            selectItem(value) {
                this.selectedRow = value
                this.$emit('change', value)
                this.cbSelected(value)
            },
            search(query, labelQry) {
                this.searchStr = query
                this.labelStr = labelQry

                this.fetchData()
            }
        },
    }

</script>

<style lang="scss">

</style>
